require('es6-promise/auto')
require('whatwg-fetch')

module.exports = require('./')
